import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { HomeBrandsMarqueeWrapper } from "./HomeBrandsMarquee.styles"
import { prefixStatamicAssetUrl } from "../../../utils/statamicAssets"

/**
 * @returns {{
 *   brandsTitle: string | null,
 *   brandLogos: {
 *     title: string,
 *     fixed: {
 *       src: string,
 *       width: number,
 *       height: number
 *     }
 *   }[]
 * }|null}
 */
function useHomeBrands(){
  const query = useStaticQuery(graphql`
    query HomeBrandsQuery {
      statamic {
        entries(collection: "home", limit: 1) {
          data {
            ... on Statamic_Entry_Home_Home {
              brands_title
              brand_logos {
                url
                permalink
                ... on Statamic_Asset_Assets {
                  alt
                  width
                  height
                }
              }
            }
          }
        }
      }
    }
  `)

  const node = query?.statamic?.entries?.data?.[0]
  if(!node) return null

  const brandLogos = (node.brand_logos || [])
    .filter(logo => logo && (logo.permalink || logo.url))
    .map(logo => {
      const src = `${prefixStatamicAssetUrl(logo.permalink || logo.url)}?w=250&fit=contain`
      const width = 250
      const height = logo.width && logo.height
        ? Math.round(logo.height * (width / logo.width))
        : undefined
      return {
        title: logo.alt || "",
        fixed: { src, width, height },
      }
    })

  if(!brandLogos.length) return null

  return {
    brandsTitle: node.brands_title || null,
    brandLogos,
  }
}

export default function HomeBrandsMarquee(){
  const homeBrands = useHomeBrands()
  if(!homeBrands) return null
  return (
      <HomeBrandsMarqueeWrapper className="px-3">
        <div className="container">
          {homeBrands.brandsTitle && <h2>{homeBrands.brandsTitle}</h2>}
          <div className="marquee-container">
            <div className="marquee">
              <ul className="marquee-content">
                {homeBrands.brandLogos.map((logo, index) => (
                  <li key={`original-${index}`}>
                    <img src={logo.fixed.src} alt={logo.title} width={logo.fixed.width} height={logo.fixed.height} />
                  </li>
                ))}
                {homeBrands.brandLogos.map((logo, index) => (
                  <li key={`duplicate-${index}`} aria-hidden="true">
                    <img src={logo.fixed.src} alt={logo.title} width={logo.fixed.width} height={logo.fixed.height} />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </HomeBrandsMarqueeWrapper>
  )
}
